<h2 mat-dialog-title>Crear columnas desde JSON</h2>

<mat-dialog-content class="dialog-content">
  <p class="dialog-help">
    Pega un arreglo JSON con esta estructura:
    <code>[&#123;"label":"Canal","name":"canal","type":"string","optional":true&#125;]</code>
  </p>

  <mat-form-field appearance="outline" class="json-textarea">
    <mat-label>JSON de columnas</mat-label>
    <textarea
      matInput
      rows="12"
      [(ngModel)]="jsonText"
      placeholder='[{"label":"Canal","name":"canal","type":"string","optional":true}]'>
    </textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="apply()">Crear columnas</button>
</mat-dialog-actions>
